/**
 * Conversation types tracked by `ConversationsContext`. The TalkJS session
 * exposes unread state across every conversation the current user participates
 * in — including unrelated domains like TCAPI (text-to-911) — so consumers
 * must scope queries by type.
 *
 * Only `'interagency'` is supported today; other domains have their own
 * contexts/hooks. Extend the union when we need to aggregate additional
 * domains here.
 */
export type ConversationType = 'interagency';

/**
 * TalkJS conversation IDs are prefixed by domain (e.g. `interagency.<uuid>`,
 * `tcapi.<uuid>`). Used to filter the shared `summaries` map down to a single
 * conversation type.
 */
export const CONVERSATION_ID_PREFIX: Record<ConversationType, string> = {
  interagency: 'interagency.',
};
